import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { fileExtensionStylingMap, genericFile } from "~/components/FileExtensionPreview/types";
export const AssetMobileVersionsListItemThumbnailPreview = /*#__PURE__*/ memo((param)=>{
    let { ext } = param;
    const extStyles = useMemo(()=>{
        const normalizedExt = (ext === null || ext === void 0 ? void 0 : ext.toLowerCase()) || ""; // to support e.g. JPG
        return normalizedExt in fileExtensionStylingMap ? fileExtensionStylingMap[normalizedExt] : genericFile;
    }, [
        ext
    ]);
    const IconComponent = extStyles.iconComponent;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex size-full items-center justify-center text-grey-12",
        style: {
            color: extStyles.iconColor,
            backgroundColor: extStyles.bgColor
        },
        children: /*#__PURE__*/ _jsx(IconComponent, {
            className: "size-6 text-current"
        })
    });
});
AssetMobileVersionsListItemThumbnailPreview.displayName = "AssetMobileVersionsListItemThumbnailPreview";
